module.exports = {"150403001":"西露天街道","150403002":"平庄城区街道","150403003":"平庄东城街道","150403004":"平庄西城街道","150403005":"马林街道","150403006":"云杉路街道","150403100":"风水沟镇","150403101":"元宝山镇","150403102":"美丽河镇","150403103":"平庄镇","150403104":"五家镇","150403200":"小五家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150403.json
// module id = 371
// module chunks = 0